import TextLink from "../../../common/components/TextLink"

export default function WatchHelpVideoLink({ linkProps = {} }) {
  return (
    <TextLink
      to="https://vimeo.com/1092823886/5f8ce9af92?share=copy"
      text="Watch help video"
      linkProps={{ target: "_blank", ...linkProps }}
    />
  )
}
